import { StyleRoot } from "radium";
import React from "react";
import CardContent from "./CardContent";
import { CarouselCard, SectionTitle } from "tomo-react-components";
import styles from "../styles/board";
import data from "../data";

const cards = data.cards;

const iconCards = data.iconCards.map((cardData, i) => {
  return {
    cardContent: (
      <CardContent iconName={cardData.iconName} iconText={cardData.iconText} />
    ),
    additionalText: cardData.additionalText,
  };
});

function FactsBoard({}) {
  return (
    <StyleRoot>
      <div style={styles.wrapper}>
        <div style={styles.quickFacts.wrapper}>
          <div
            style={styles.quickFacts.title}
            role={"heading"}
            aria-level={"1"}
          >
            <SectionTitle.component
              align="right"
              title={["Some", <br />, "quick", <br />, "facts"]}
            />
          </div>
          <div style={styles.quickFacts.content}>
            {cards.map((content, i) => (
              <div key={i} style={styles.quickFacts.contentCard}>
                <CarouselCard.component
                  key={i}
                  cardContent={content.cardContent}
                  additionalText={content.additionalText}
                  height="auto"
                  border="none"
                  justifyContent="flex-start"
                  cardFontSize="30px"
                  textAlign="left"
                  textMargin="10px 80px 50px 0"
                />
              </div>
            ))}
          </div>
        </div>
        <div style={styles.consumers.wrapper}>
          <div style={styles.consumers.content}>
            {iconCards.map((content, i) => (
              <div key={i} style={styles.consumers.contentCard}>
                <CarouselCard.component
                  key={i}
                  cardContent={content.cardContent}
                  additionalText={content.additionalText}
                  height="150px"
                  width="150px"
                  textMargin="20px 0 0"
                />
              </div>
            ))}
          </div>
          <div style={styles.consumers.title} role={"heading"} aria-level={"1"}>
            <SectionTitle.component
              align="left"
              title={[
                "Who",
                <br />,
                "shops on",
                <br />,
                "touch of",
                <br />,
                "modern?",
              ]}
            />
          </div>
        </div>
      </div>
    </StyleRoot>
  );
}

export default FactsBoard;
